<div class="d-flex justify-content-between align-items-center mb-0">
  <div>
    <h1 class="fs-5 fw-bold mb-0">{{title}}</h1>
    <span class="fs-7 text-subheading">{{description}}</span>
  </div>
  <div class="d-flex align-items-center position-relative gap-2">
    <span class="fs-6 fw-medium text-muted calendar-trigger" (click)="toggleCalendar()" *ngIf="!showCalendar">
      {{getCurrentMonthYear()}}
      <i class="fas fa-calendar ms-1"></i>
    </span>
    <button
      type="button"
      class="today-link-button"
      (click)="goToToday()"
      *ngIf="showCalendar">
      <i class="fas fa-calendar-day me-1"></i>
      Today
    </button>
  </div>
</div>

<div class="week-grid" *ngIf="!showCalendar">
  <div class="day-column" *ngFor="let day of weekDays; let i = index" [ngClass]="{
          'selected': day.isSelected,
          'current-day': day.isCurrentDay
        }" (click)="selectDate(day, i)">

    <div class="day-header">
      <span class="day-name">{{day.day}}</span>
      <div class="day-date">
        <span class="date-number">{{day.date}}{{getDateSuffix(day.date)}}</span>
      </div>
    </div>

    <div class="day-count">
      <span class="count-number">{{day.count}}</span>
    </div>
  </div>
</div>

<div class="calendar-view" *ngIf="showCalendar">
  <p-calendar [(ngModel)]="calendarDate" (onSelect)="onCalendarDateSelect($event)" [inline]="true" [showIcon]="true"
    dateFormat="dd/mm/yy" [showWeek]="false" [firstDayOfWeek]="0">
  </p-calendar>
</div>